<template>
  <section id="investors">
    <div class="container tw-px-4">
      <div class="tw-bg-white tw-rounded-lg lg:tw-mx-4">
        <div class="tw-mb-10 md:tw-ml-auto tw-w-max">
          <!-- <CustomButton
            title="Add members to this deal"
            @click="$emit('show-member-form', true)"
          /> -->
          <exportToCsv
            v-if="dealInvestors && dealInvestors.length !== 0"
            docType="Investors"
            :fileName="token.name"
            :data="dealInvestors"
          />
        </div>
        <div>
          <div class="table-container">
            <InvestorsTable
              :hasStatus="false"
              v-if="dealInvestors && dealInvestors.length !== 0"
              :tableHeaders="tableHeaders"
              :tableRows="tableRows"
              :columnNumber="tableHeaders.length - 1"
              :columnWidth="170"
              :totalPage="1"
              :currentPage="1"
              @gotoPage="null"
            />
            <EmptyState v-if="dealInvestors && dealInvestors.length === 0">
              <template v-slot:message>
                <p
                  v-if="status === 'All members'"
                  class="message tw-text-center tw-text-gray tw-my-3"
                >
                  There are no members on this account.
                </p>
                <p
                  v-if="status === 'Waitlist'"
                  class="message tw-text-center tw-text-gray tw-my-3"
                >
                  There are no pending members on this account.
                </p>
                <p
                  v-if="status === 'Deactivated'"
                  class="message tw-text-center tw-text-gray tw-my-3"
                >
                  There are no deactivated members on this account.
                </p>
              </template>
            </EmptyState>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import InvestorsTable from "@/components/tables/InvestorTable";
  import EmptyState from "@/components/notification/EmptyState";
  import { truncate } from "@/utils/helpers.js";
  import CustomButton from "@/components/general/BtnComponent";
  import { mapGetters, mapActions } from "vuex";
  import exportToCsv from "@/components/general/exportToCSV";
  export default {
    name: "Investors",
    components: {
      InvestorsTable,
      EmptyState,
      CustomButton,
      exportToCsv,
    },
    data() {
      return {
        tableHeaders: [
          "Name",
          "Email",
          "Phone number",
          "Address",
          "Investment amount",
        ],
        tableRows: [],
      };
    },
    emits: ["show-member-form", "add-member-form"],
    props: {
      tokenId: {
        type: String,
        required: true,
      },
    },
    computed: {
      ...mapGetters("TokenModule", ["dealInvestors", "token"]),
    },
    mounted() {
      if (this.tokenId) {
        this.getAllInvestors();
      }
    },
    watch: {
      dealInvestors(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.updateTableRow();
        }
      },
    },
    methods: {
      ...mapActions("TokenModule", ["fetchDealInvestors"]),
      async getAllInvestors() {
        try {
          await this.fetchDealInvestors(this.tokenId);
          this.updateTableRow();
        } catch (error) {
          return error;
        }
      },

      updateTableRow() {
        this.tableRows = this.dealInvestors.map((investor) => {
          let name = `${investor.fname} ${investor.lname}`;
          return {
            name: name,
            email: truncate(investor.email, 25),
            phone: truncate(investor.phone ? investor.phone : "-", 25),
            address: truncate(
              investor.homeAddress ? investor.homeAddress : "-",
              25
            ),
            investment: `${new Intl.NumberFormat().format(
              investor.balance
            )}`,
          };
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  #investors {
    width: 100%;
    overflow: hidden;

    .container {
      @include fadeIn;

      @media screen and (min-width: 1024px) {
        max-width: 1280px;
        margin-left: auto;
        margin-right: auto;
      }
    }

    .table-container {
      overflow: auto;
    }

    .message {
      max-width: 250px;
    }
  }
</style>
